export default {
  online_payments_off:
    'La entrega está activada, pero los clientes no pueden pedirla: la entrega con repartidor solo se paga en línea y los pagos en línea están desactivados.',
  gateway_not_verified:
    'La entrega está activada, pero los clientes no pueden pedirla: la entrega con repartidor solo se paga en línea y los pagos en línea están en pausa hasta que se verifique tu cuenta de pago.',
  stripe_processing_fee_missing:
    'La entrega a domicilio está activada, pero los clientes no pueden pedirla: la entrega con repartidor solo se paga online, y los pagos online están en pausa hasta que tu partner establezca su comisión de procesamiento.',
  turn_on_online_payments: 'Activar pagos en línea',
};
